export default __webpack_public_path__ + "static/media/duplex_115.cf9d9d2e.png";